export default __webpack_public_path__ + "static/media/floorusageicon.cb2ed335.svg";